/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


(function(){

    /**
     * Main product form
     */
    const form = document.querySelector('form.ProductForm')

    if(form) {

        /**
         * Targets
         */
        const elements = {

            // Always present inputs
            inputs: form.querySelectorAll('[data-product-input-engraving]'),

            // Conditionally visible inputs based on variant ID
            variantInputs: form.querySelectorAll('[data-product-variant-engraving-input]'),

            addToCart: form.querySelector('button[type=submit]'),
            confirmation: form.querySelector('[data-product-input-confirmation]'),
        }

        /**
         * Go no further if required elements are not present
         */
        if((!elements.inputs && !elements.variantInputs) || !elements.addToCart || !elements.confirmation) return;

        /**
         * Sets the 'disabled' attribute on the element based on the state.
         * If the state is true or all inputs are empty, it enables the element.
         * Otherwise, it disables the element.
         *
         * @param {HTMLElement} el - The element to enable or disable.
         * @param {boolean} state - The state to determine whether to enable or disable the element.
         */
        const setAddToCartState = (el, state) => {
            if(state || allInputsEmpty()) {
                el.removeAttribute('disabled');
            } else {
                el.setAttribute('disabled', true);
            }
        };

        /**
         * Sets the checked property of a checkbox element.
         *
         * @param {HTMLInputElement} el - The checkbox element.
         * @param {boolean} state - The state to set the checkbox to (true for checked, false for unchecked).
         */
        const setCheckboxValue = (el, state) => {
            el.checked = state;
        };

        /**
         * Show or hide an element based on the variant ID.
         * Hides all other elements with the same data attribute.
         *
         * @param {string} variantID - The ID of the variant.
         */
        const toggleInputVisibility = (variantID) => {
            // Select the specific element based on the variant ID
            const targetElement = Array.from(elements.variantInputs).find(el => el.getAttribute('data-product-variant-engraving-input') == variantID);

            // Hide all elements except the active one or all if targetElement is null
            elements.variantInputs.forEach(el => {
                const value = el === targetElement ? 'block' : 'none'
                el.value = ''
                el.closest('.ProductForm__Option').style.display = value;

                elements.confirmation.checked = false
            });

            // Hide the checkbox if there is no input found for the selected varient
            targetElement ? toggleCheckboxVisibility(true) : toggleCheckboxVisibility(false)
        };

        /**
         * Show or hide an element based on the variant ID.
         * Hides all other elements with the same data attribute.
         *
         * @param {string} variantID - The ID of the variant.
         */
        const toggleCheckboxVisibility = (state) => {
            if(!elements.confirmation) return

            // Don't hide if we have product level engraving inputs
            if(elements.inputs.length) return

            const value = state ? 'block' : 'none'

            elements.confirmation.closest('.Form__Item').style.display = value
        };

        /**
         * Checks if all input elements are empty.
         *
         * @returns {boolean} - Returns true if all input elements are empty, false otherwise.
         */
        const allInputsEmpty = () => {
            let allEmpty = true;

            [...elements.inputs, ...elements.variantInputs].forEach((el) => {
                if(el.value.length > 0) {
                    allEmpty = false;
                }
            });

            return allEmpty;
        };

        /**
         * Initializes the variant change listener on a Shopify product page.
         * Shows or hides an input based on whether the variant ID is in the predefined array.
         */
        const initVariantChangeListener = () => {

            // Listen for the custom 'variant:changed' event
            document.addEventListener('variant:changed', (event) => {
                // Get the new variant from the event details
                const newVariant = event.detail.variant;

                if (newVariant) {
                    
                    // Show or hide the input based on the variant ID if there is a related checkbox found
                    toggleInputVisibility(newVariant.id);
                } else {
                    console.error('No variant information found in event details.');
                }
            });
        };

        /**
         * Adds event listeners to inputs and checkbox elements to update the state
         * of the "add to cart" button and checkbox based on user interactions.
         */
        const addEventListeners = () => {
            // Update add to cart state and checkbox state based on input value
            [...elements.inputs, ...elements.variantInputs].forEach((input) => {
                input.addEventListener('keyup', (e) => {
                    if(e.target.value.length > 0) {
                        // If input is not empty, disable add to cart
                        setCheckboxValue(elements.confirmation, false);
                        setAddToCartState(elements.addToCart, false);
                    } else if (allInputsEmpty()) {
                        // Check if all inputs are empty, and if so enable add to cart
                        setCheckboxValue(elements.confirmation, false);
                        setAddToCartState(elements.addToCart, true);
                    }
                });
            });

            // Set add to cart button state on checkbox toggle
            elements.confirmation.addEventListener('change', () => {
                elements.confirmation.checked ? setAddToCartState(elements.addToCart, true) : setAddToCartState(elements.addToCart, false);
            });

            if(elements.variantInputs.length) {
                initVariantChangeListener()
            }
        };

        addEventListeners()
    }
}())
